export const SIGN_IN_URL = '/idaw-service/authenticate';
export const SIGN_UP_URL = '/idaw-service/register';
export const USER_INFO_URL = '/idaw-service/userinfo';

export const GET_USER_INFO_KEY = 'user-info';
